const styles = theme => ({
  modal: {
    maxWidth: '400px',
    color: theme.palette.primary.white,
    padding: '24px',
    borderRadius: '0px',
    boxShadow: 'none',
  },

  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '16px',
  },

  headerTitle: {
    flex: 1,
    color: theme.palette.primary.adgmBlack,
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '27px',
  },
  headerCloseBtn: {
    minWidth: 'auto',
    background: 'transparent',
    padding: '6px',
    borderRadius: '0%',
  },

  headerCloseBtnIcon: {
    width: '16px',
    height: '16px',
  },

  description: {
    marginTop: '16px',
    color: theme.palette.primary.adgmBlack,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '21px',
  },

  actions: {
    marginTop: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
  },

  actionBtn: {
    flex: 1,
    padding: '12px 30px',
    borderRadius: '0px',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
  },
  cancelBtn: {
    flex: 1,
    backgroundColor: theme.palette.primary.white,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    '&:focus': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
    },
  },
  proceedBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.main}`,
    '&:focus': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
    },
  },

  disableBtn: {
    backgroundColor: `${theme.palette.secondary.disableLightGray} !important`,
    color: `${theme.palette.primary.darkGrey} !important`,
    border: `1px solid ${theme.palette.secondary.disableLightGray} !important`,
  },
});

export default styles;
